
import { AnalyticsService } from './analyticsService';

// Export types
export type { AnalyticsEvent, AnalyticsProperties, UserProperties } from './types';
export type { AnalyticsConfig } from './config';

// Export singleton instance
export const analytics = new AnalyticsService();

// Export service class and utilities for testing
export { AnalyticsService };
export { PostHogIntegration } from './postHogIntegration';
export { AnalyticsUtils } from './analyticsUtils';
